import React from "react";
import PropTypes from "prop-types";
import * as Styles from "./styles";

function Apresentacao(props) {
  const noticia = props.noticia;
  const imageUrl = noticia.noticia_img_path;
  const titulo = noticia.titulo;

  return (
    <Styles.Sessao>
      <Styles.Container>
        <Styles.Header>
          <a href="/noticias">Noticias</a>
          <p> / {titulo}</p>
        </Styles.Header>

        <img src={imageUrl} alt="Imagem da noticia" />
      </Styles.Container>
    </Styles.Sessao>
  );
}

Apresentacao.propTypes = {
  noticia: PropTypes.object,
};

export default Apresentacao;
